import * as S from './style'
import Logo from '../../assets/logoMundial.svg'
import { NavLink, useLocation } from "react-router-dom";
/**
 * Icons 
*/
import { ArrowLeft } from '@phosphor-icons/react';

export default function MensagemEmail() {
  const location = useLocation();
  const email = location.state?.email || "não informado";

  return (
    <S.Container>
      <S.Content>
        <S.ContentImage>
          <S.Image src={Logo} alt="Logo Óticas Mundial" />
        </S.ContentImage>

        <S.Header>
          <S.H3>E-mail enviado com sucesso!</S.H3>
          <S.TextP>
            Enviamos um e-mail para <span>{email}</span>. Por favor, acesse sua caixa de entrada e siga as instruções para redefinir sua senha.
          </S.TextP>
        </S.Header>

        <NavLink to="/" style={{ textDecoration: "none" }}>
          <S.Footer>
            <ArrowLeft size={20} />
            <S.ReturnPageLogin>
              Voltar para página de
              <span>Login.</span>
            </S.ReturnPageLogin>
          </S.Footer>
        </NavLink>
      </S.Content>
    </S.Container>
  );
}